import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileClock, ChevronRight } from 'lucide-react';
import api from '@/lib/api';

export function StatusDigestCard({ navigate }) {
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    api.get('/dashboard/status-digest')
      .then(r => setEntries(r.data.entries || []))
      .catch(() => setEntries([]));
  }, []);

  if (!entries) return null;

  return (
    <Card className="border-white/10 bg-card shadow-none" data-testid="status-digest-card">
      <CardHeader className="pb-2 border-b border-white/[0.08]">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <FileClock className="h-3.5 w-3.5 text-primary shrink-0" /> Project Status Digest
          <span className="text-xs text-muted-foreground/70 font-normal">last 7 days</span>
          <span className="text-xs text-muted-foreground/70 ml-auto tabular-nums">{entries.length}</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-2 space-y-0">
        {entries.length === 0 ? (
          <p className="text-xs text-muted-foreground">No status updates on your projects in the last 7 days</p>
        ) : (
          entries.map(e => (
            <button
              key={e.id}
              type="button"
              className="w-full text-left py-2 border-b border-white/[0.06] last:border-0 hover:bg-secondary/20 transition-colors rounded-sm group"
              onClick={() => navigate(`/projects/${e.project_id}?tab=status`)}
              data-testid={`status-digest-entry-${e.id}`}
            >
              <div className="flex items-center justify-between gap-2">
                <p className="text-xs font-mono text-primary truncate">{e.project_label}</p>
                <ChevronRight className="h-3 w-3 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity shrink-0" />
              </div>
              <p className="text-sm font-normal mt-0.5 line-clamp-2">{e.snippet}</p>
              <p className="text-xs text-muted-foreground mt-0.5">
                {e.author && `${e.author} · `}{e.created_at ? new Date(e.created_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) : ''}
              </p>
            </button>
          ))
        )}
      </CardContent>
    </Card>
  );
}
